const ipfsGateway =
  process.env.NEXT_PUBLIC_IPFS_GATEWAY || "https://test.trexprotocol.com";
const videoIpfsGateway =
  process.env.NEXT_PUBLIC_IPFS_GATEWAY_MEDIA ||
  "https://media.trexprotocol.com";

export const transformIpfs = (
  ipfs: string,
  width?: number,
  quality: number = 85,
  type: "image" | "video" | "giphy" = "image",
) => {
  if (typeof ipfs !== "string") {
    return ipfs;
  }
  if (ipfs.startsWith("http://") || ipfs.startsWith("https://")) {
    if (ipfs?.includes(".") && !ipfs?.includes("?")) {
      return ipfs; //`${ipfs}?image_process=resize,w_${width}`;
    }
  }
  if (!ipfs.startsWith("ipfs://")) {
    return ipfs;
  }
  const gateway = type === "image" ? ipfsGateway : videoIpfsGateway;
  if (width && width > 1) {
    const format = type === "image" ? "ipfs" : "hls/1280_720.m3u8";
    const result = ipfs.replace(
      "ipfs://",
      `${gateway}/cdn-cgi/image/width=${Math.floor(width)},quality=${quality}/${format}/`,
    );
    return result;
  }
  if (type === "image") {
    return ipfs.replace("ipfs://", `${gateway}/ipfs/`);
  }
  return `${ipfs.replace("ipfs://", `${gateway}/hls/`)}/1280_720.m3u8`;
};
